import { TextFieldProps } from "@mui/material";
import { FieldProps } from "formik";
import { fieldToTextField } from "formik-mui";
import React from "react";
import { DedicatedValues } from "../../../DeskManagementDialog";
import { DedicatedAutocomplete } from "./DedicatedAutocomplete";

export interface FormikDedicatedAutocompleteProps
  extends FieldProps<DedicatedValues>,
    Omit<TextFieldProps, "name" | "value" | "error" | "onChange"> {
  multiple?: boolean;
}

export const FormikDedicatedAutocomplete: React.FC<
  FormikDedicatedAutocompleteProps
> = ({ multiple, ...fieldProps }) => {
  const { field, form } = fieldProps;
  const dedicatedValues: DedicatedValues = field.value ?? {
    memberships: [],
    teamIds: [],
  };

  const handleDedicatedChange = (newValues: DedicatedValues) =>
    form.setFieldValue(field.name, newValues);

  const {
    onChange: _ignoreOnChange,
    value: _ignoreValue,
    name: _ignoreName,
    ...textFieldProps
  } = fieldToTextField(fieldProps);

  return (
    <DedicatedAutocomplete
      {...textFieldProps}
      multiple={multiple ?? false}
      value={dedicatedValues.memberships}
      showTeamAsClickable={true}
      selectedTeamIds={dedicatedValues.teamIds}
      onDedicatedChange={handleDedicatedChange}
    />
  );
};
